module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": true,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE USUARIOS AUTH0: "), _c('a', {
    staticStyle: {
      "font-size": "18px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.cont))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.allTrabs), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.verData(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verData(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                    Se anulará el usuario " + _vm._s(_vm.user) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anular()
      }
    }
  }, [_vm._v("Anular Usuario")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Usuario\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text",
      "required": "true",
      "placeholder": "Ingrese Usuario"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Password\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clave),
      expression: "clave"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "password",
      "required": "true",
      "placeholder": "Ingrese Clave"
    },
    domProps: {
      "value": (_vm.clave)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clave = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "padding-top": "10px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n                    El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido el\n                    guión abajo y por último su número de DNI.\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.editar()
      }
    }
  }, [_vm._v("Guardar Cambios")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "USUARIO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CORREO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "EDITAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("EDITAR")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEA ANULAR EL USUARIO?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("ACTUALIZAR DATOS DE USUARIO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a488cf1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UsuariosAuth.vue
// module id = 332
// module chunks = 1